<template>
  <div class="page page-service-works">
    <router-link to="/service-works/create" class="btn btn-primary w-100">
      Добавить
    </router-link>
    <br />
    <!-- TODO: <button>ДОБАВИТЬ ГРУППУ</button> -->
    <div class="draggable-cards-wrapper">
      <draggable
        class="list-group"
        tag="ul"
        style="width: 100%; height: 100%"
        v-model="works"
        v-bind="dragOptions"
        :move="onMove"
        @start="isDragging = true"
        @end="isDragging = false"
      >
        <li v-for="element in works" :key="element.id" class="list-group-item" style="display: flex">
          <font-awesome-icon
            icon="grip-lines"
            size="1x"
            style="align-self: center; color: rgb(64, 64, 64); margin-right: 0.4rem"
          />
          {{ element.name }}
          <span class="badge" style="line-height: unset">
            {{ element.interval ? `Каждые ${element.interval} км.` : "без интервала" }}
          </span>
          {{ element.archived_at }}
          <font-awesome-icon
            icon="pen"
            size="1x"
            :style="{
              color: 'gray',
              'margin-left': 'auto',
              cursor: 'pointer'
            }"
            @click="$router.push(`/service-works/update/${element.id}`)"
          />
          <font-awesome-icon
            icon="trash-alt"
            size="1x"
            :style="{
              color: 'gray',
              'margin-left': '1.5rem',
              cursor: 'pointer'
            }"
            @click="removeItem(element.id)"
          />
        </li>
      </draggable>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import serviceWorksApi from '@/api/service-works'

export default {
  name: 'ServiceWorks',
  components: { draggable },
  mounted () {
    this.loadItems({ sort: 'sort' })
  },
  beforeDestroy () {
    this.abortLoading()
  },
  data () {
    return {
      editable: true,
      isDragging: false,
      delayedDragging: false,
      worksCopy: null
    }
  },
  computed: {
    ...mapState('taxi/serviceWorks', {
      worksState: state => state.items.filter(e => !e.archived_at),
      isLoading: state => state.isLoading
    }),
    works: {
      get () {
        if (!this.worksCopy) {
          return JSON.parse(JSON.stringify(this.worksState))
        }

        return this.worksCopy
      },
      set (value) {
        value.forEach((v, i) => {
          this.updateItem({ ...v, sort: i })
        })
        this.worksCopy = value
      }
    },
    dragOptions () {
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      }
    }
  },
  methods: {
    ...mapActions('taxi/serviceWorks', [
      'loadItems',
      'updateItem',
      'setSorts',
      'abortLoading'
    ]),
    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    },
    removeItem (id) {
      this.works = this.works.filter(e => e.id != id)
      serviceWorksApi
        .archivateItem(id)
        .then(() => this.loadItems({ sort: 'sort' }))
    }
  }
}
</script>

<style lang="scss" scoped>
  @media screen and (max-width: 1199px) {
    .page {
      padding: 1rem;
    }
  }
  @media screen and (max-width: 576px) {
    .page {
      padding: 0.5rem;
    }
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .list-group {
    min-height: 20px;
  }
  .list-group-item {
    cursor: move;
  }
  .list-group-item i {
    cursor: pointer;
  }
  .create-service-work {
    flex: 0 1 auto;
    align-self: flex-end;
    margin: 0;
    min-width: 8rem;
  }
  .page-service-works {
    display: flex;
    flex-flow: column;
    height: 100%;
  }
  .unsorteds {
    width: 400px;
    height: 100%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    display: inline-block;
    .card-header {
      background-color: white;
    }
    .card-body {
      padding-left: 5px;
      padding-right: 5px;
      height: 100%;
    }
    ul {
      height: 100%;
    }
  }
  .workcard {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    width: 400px;
    height: 100%;
    display: inline-block;
    .card-header {
      background-color: white;
    }
    .card-body {
      padding-left: 5px;
      padding-right: 5px;
      height: 100%;
    }
    ul {
      height: 100%;
    }
  }
  .draggable-cards-wrapper {
    height: 100%;
    flex-direction: column;
    flex-flow: nowrap;
  }
  .btn .col-12 {
    width: 100vw;
  }
</style>
